import { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { Globe, Check } from "lucide-react";
import { LANGS } from "@/i18n";

export default function LanguageSwitcher({ compact = false, light = false }) {
  const { i18n } = useTranslation();
  const [open, setOpen] = useState(false);
  const menuRef = useRef(null);
  const current = LANGS.find((l) => l.code === i18n.language) || LANGS[0];

  useEffect(() => {
    const onDocClick = (e) => {
      if (menuRef.current && !menuRef.current.contains(e.target)) {
        setOpen(false);
      }
    };
    document.addEventListener("mousedown", onDocClick);
    return () => document.removeEventListener("mousedown", onDocClick);
  }, []);

  return (
    <div className="relative" ref={menuRef}>
      <button
        onClick={() => setOpen((v) => !v)}
        data-testid="lang-switch-toggle"
        className={`inline-flex items-center gap-2 rounded-lg ${light ? "text-white/80 hover:bg-white/10 hover:text-white" : "text-ink-600 hover:bg-surface-soft"} ${compact ? "p-2" : "px-2.5 py-2 text-sm"}`}
        aria-label="Change language"
      >
        <Globe className="w-4 h-4" />
        {!compact && <span className="text-xs font-medium uppercase tracking-widest">{current.code}</span>}
      </button>
      {open && (
        <div className="absolute right-0 top-full mt-2 min-w-[160px] card-soft p-1 shadow-pop z-50">
          {LANGS.map((l) => {
            const active = l.code === current.code;
            return (
              <button
                key={l.code}
                onClick={() => { i18n.changeLanguage(l.code); setOpen(false); }}
                data-testid={`lang-opt-${l.code}`}
                className={`w-full flex items-center justify-between px-3 py-2 rounded-lg text-sm ${active ? "bg-brand-50 text-brand-700" : "text-ink-700 hover:bg-surface-soft"}`}
              >
                <span>{l.label}</span>
                {active && <Check className="w-3.5 h-3.5 text-brand-600" />}
              </button>
            );
          })}
        </div>
      )}
    </div>
  );
}
